export default "/dist/files/icone_sante.82537b7998edcf34d0e5dd89a0a1b182.svg";